// extracted by mini-css-extract-plugin
export default {"percent":"style_percent__g61KC"};